import React from "react";
import PropTypes from "prop-types";
import Popover from "@mui/material/Popover";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useTranslation } from "react-i18next";

function ChatSoundSettings({
  settings,
  onUpdateSettings,
  anchorEl,
  open,
  onClose,
}) {
  const { t } = useTranslation("core");

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Box sx={{ p: 2, minWidth: 250 }}>
        <Typography variant="subtitle2" gutterBottom>
          {t("chat.soundSettings.title")}
        </Typography>

        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={settings.replySound}
                onChange={(e) =>
                  onUpdateSettings({ replySound: e.target.checked })
                }
                size="small"
              />
            }
            label={t("chat.soundSettings.reply")}
          />
          <FormControlLabel
            control={
              <Switch
                checked={settings.mentionSound}
                onChange={(e) =>
                  onUpdateSettings({ mentionSound: e.target.checked })
                }
                size="small"
              />
            }
            label={t("chat.soundSettings.mention")}
          />
          <FormControlLabel
            control={
              <Switch
                checked={settings.joinSound}
                onChange={(e) =>
                  onUpdateSettings({ joinSound: e.target.checked })
                }
                size="small"
              />
            }
            label={t("chat.soundSettings.join")}
          />
        </FormGroup>
      </Box>
    </Popover>
  );
}

ChatSoundSettings.propTypes = {
  settings: PropTypes.shape({
    replySound: PropTypes.bool,
    mentionSound: PropTypes.bool,
    joinSound: PropTypes.bool,
  }).isRequired,
  onUpdateSettings: PropTypes.func.isRequired,
  anchorEl: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ChatSoundSettings;
